module.exports = __webpack_public_path__ + "static/media/photo-certification.02f428a4.jpg";